import { clsx } from "clsx";
import { useState } from "react";

const maxLength = 400;
function truncateString(string: string) {
  if (string.length > maxLength) {
    return `${string.slice(0, maxLength).trim()}...`;
  }
  return string;
}
export default function ExpandableText({
  children,
  className = undefined,
}: {
  children: string;
  className?: string;
}) {
  const [isExpanded, setIsExpanded] = useState(
    children && children.length < maxLength,
  );

  return (
    <div className={clsx("mt-2 flex flex-col", className)}>
      <p className="whitespace-pre-wrap break-all text-xs">
        {isExpanded ? children : truncateString(children)}
      </p>
      {!isExpanded && (
        <button
          className="ml-auto text-button-xs text-purple-600"
          type="button"
          onClick={() => setIsExpanded(true)}
        >
          ...see more
        </button>
      )}
    </div>
  );
}
